import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_OptProgram = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_OptProgram' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'>
                    <center><b>Mission Statement</b></center>
                    <br />
                    Amethyst is committed to developing and providing the latest, most effective treatment practices and, in
                    all things, promoting dignity, compassion, and respect for clients and their families as the absolute
                    standard.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Outpatient:</span>
                    Outpatient behavioral health services (OPT) include psychiatric and bio- psychosocial assessment,
                    individual, group, and family therapies, psychotherapy for crisis, and psychological testing for eligible NC
                    Medicaid (Medicaid is NC Medicaid program, unless context clearly indicates otherwise) and NC Health
                    Choice (NCHC is NC Health Choice program, unless context clearly indicates otherwise) beneficiaries.
                    <br />
                    <br />
                    These services are intended to determine a beneficiary&#39;s treatment needs, and to provide the necessary
                    treatment. Services focus on reducing psychiatric and behavioral symptoms in order to improve the
                    beneficiary&#39;s functioning in familial, social, educational, or occupational life domains.
                    <br />
                    <br />
                    Outpatient behavioral health services are available to eligible beneficiaries and often involve the
                    participation of family members, significant others, and legally responsible person(s), as applicable,
                    unless contraindicated.
                    <br />
                    <br />
                    Based on collaboration between the practitioner and beneficiary, and others as needed, the beneficiary&#39;s
                    needs and preferences determine the treatment goals, frequency and duration of services, as well as
                    measurable and desirable outcomes
                </p>

                <p className='w-750'>
                    <b>I have read and I understand the OPT Program Description above.</b>
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Client/Responsible Party Signature:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Amethyst Representative Signature:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>



            </div>
        </form>

    )
}  
